
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/stock-prices-table",
      function () {
        return require("private-next-pages/embed/stock-prices-table.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/stock-prices-table"])
      });
    }
  